import React from 'react';
import {
  Link,
  useHistory,
  Switch,
  useRouteMatch,
  Redirect,
} from 'react-router-dom';

import Route from 'react-router-dom/Route';
import styled from '@emotion/styled';
import Colors from '../../theme/Colors';
import { Grid } from '@material-ui/core';
import RelatorioWhatsapp from './whatsapp';
import { withBaseLayout } from '../../layout/base-layout';
import PagamentoIA from './pagamento-ia';
import RelatorioVendas from './vendas';

const subMenus = [
  {
    title: 'WhatsApp',
    uri: 'whatsapp',
    component: RelatorioWhatsapp,
  },
  {
    title: 'Pagamentos IA',
    uri: 'pagamento-ia',
    component: PagamentoIA,
  },
  {
    title: 'Vendas',
    uri: 'vendas',
    component: RelatorioVendas,
  },
];

const Relatorios = () => {
  const history = useHistory();
  const { path, url } = useRouteMatch();

  return (
    <Content>
      <SubMenu>
        {subMenus.map((item, index) => {
          const fullUrl = `${url}/${item.uri}`;
          return (
            <LinkStyled
              to={fullUrl}
              key={index}
              isSelected={history.location.pathname === fullUrl}
            >
              {item.title}
            </LinkStyled>
          );
        })}
      </SubMenu>

      <Switch>
        <Route exact path={path}>
          <Redirect to={`${url}/${subMenus[0].uri}`} />
        </Route>

        {subMenus.map(({ uri, component: Component }) => (
          <Route
            key={uri}
            exact
            path={`${path}/${uri}`}
            component={Component}
          />
        ))}
      </Switch>
    </Content>
  );
};

export default withBaseLayout(Relatorios, { hasSubMenu: true });

const Content = styled(Grid)`
  display: grid;
  grid-template-columns: 240px 1fr;
  width: 100%;
  height: calc(100vh - 80px);
  background-color: #f5f5f5;
  overflow: hidden;
`;

const SubMenu = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.commons.grayLight};
`;

const LinkStyled = styled(Link)`
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0 16px;
  margin: 16px 0 0 16px;
  border-radius: 16px 0 0 16px;
  text-decoration: none;
  color: #505050;
  background-color: ${({ isSelected }) =>
    isSelected && 'rgba(38, 172, 169, 0.1)'};
`;
